import { Vegnettlenke } from '@/domain/vegnett/Vegnettlenke';
import React from 'react';

interface LenkeegenskapProps {
    property: string;
    value?: React.ReactNode;
    vegnettlenke: Vegnettlenke;
    key?: string | number;
}

function getPropertyValue(property: string, vegnettlenke: Vegnettlenke): React.ReactNode {
    const propertyValues: Record<string, React.ReactNode> = {
        typeveg: vegnettlenke.typeVeg,
        detaljnivå: vegnettlenke.detaljnivå,
        type: vegnettlenke.type,
        topologinivå: vegnettlenke.topologinivå,
        medium: vegnettlenke.medium,
        målemetode: vegnettlenke.målemetode,
        måledato: vegnettlenke.måledato,
        lengde: vegnettlenke.lengde,
        fylke: vegnettlenke.fylke,
        kommune: vegnettlenke.kommune,
        veglenkesekvensid: vegnettlenke.veglenkesekvensid,
        startposisjon: vegnettlenke.startposisjon,
        sluttposisjon: vegnettlenke.sluttposisjon,
        veglenkenummer: vegnettlenke.veglenkenummer,
        segmentnummer: vegnettlenke.segmentnummer,
        startnode: vegnettlenke.startnode,
        sluttnode: vegnettlenke.sluttnode,
    };

    return propertyValues[property];
}

export default function Lenkeegenskap({
    property,
    value,
    vegnettlenke,
    key = vegnettlenke.referanse,
}: LenkeegenskapProps): React.JSX.Element | null {
    const verdi = value ?? getPropertyValue(property, vegnettlenke);
    const capitalized = `${property.charAt(0).toUpperCase()}${property.substring(1)}:`;

    if (verdi != null) {
        return (
            <React.Fragment key={`rnFragment${key}`}>
                <dt
                    key={`dtRn${key}`}
                    className="c-valgt-features__dt"
                    title={capitalized}
                >
                    {capitalized}
                </dt>
                <dd key={`ddRn${key}`} className="c-valgt-features__dd">
                    {verdi}
                </dd>
            </React.Fragment>
        );
    }

    return null;
}
